/*
Using intersection observer is way more efficient than adding a scroll listener for this task
*/
const header = document.getElementById("site-header");
const scrollIndicator = document.getElementById("site-header-scroll-indicator");
if (header && scrollIndicator) {
    const scrollDeterminer = new IntersectionObserver(headerScrollHandler, {});
    scrollDeterminer.observe(scrollIndicator);
}

/**
 * @param {IntersectionObserverEntry[]} entries
 *
 * @return void
 */
function headerScrollHandler(entries) {
    entries.forEach((entry) => {
        header?.toggleAttribute("data-scrolled", !entry.isIntersecting);
    });
}
